import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import BonusMalusItem from './BonusMalusItem';
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CreateBonusMalusModal from './CreateBonusMalusModal';

const BonusMalusList = ({
  scoreType,
  scoreList,
  updateTotalPoints,
  formData,
  playerType
}) => {
  const updateBMPoints = (categoryId, scoreId, scoreObject) => {
    updateTotalPoints(scoreType, categoryId, scoreId, scoreObject);
  };

  const getQuantity = (catId, scoreId) => {
    const foundElement = formData[scoreType].find(
      element => element.category === catId && element.id === scoreId
    );
    if (foundElement) {
      return foundElement.quantity;
    } else {
      return 0;
    }
  };

  const [modalShow, setModalShow] = useState(false);

  return (
    <div id={scoreType + 'List'}>
      <CreateBonusMalusModal
        scoreType={scoreType}
        playerType={playerType}
        modalShow={modalShow}
        setModalShow={setModalShow}
      />
      {scoreList?.map(categoryItem => (
        <>
          <div className="row mx-0 py-3 align-items-center border-bottom border-200 text-center">
            <h5 className="mb-0">
              <strong>{categoryItem.category}</strong>
            </h5>
          </div>
          <Row className="gx-card mx-0 bg-200 text-900 fs-10 fw-semibold">
            <Col xs={9} md={7} className="py-2">
              {scoreType == 'bonus' ? 'Bonus' : 'Malus'}
            </Col>
            <Col xs={3} md={5}>
              <Row>
                <Col md={8} className="py-2 d-none d-md-block text-center">
                  Quantità
                </Col>
                <Col xs={12} md={4} className="text-end py-2">
                  Punti
                </Col>
              </Row>
            </Col>
          </Row>
          {categoryItem.list.map(bonusMalusItem => (
            <BonusMalusItem
              key={bonusMalusItem.id}
              bonusMalusObject={bonusMalusItem}
              categoryId={categoryItem.id}
              quantity={getQuantity(categoryItem.id, bonusMalusItem.id)}
              updateBMPoints={updateBMPoints}
            />
          ))}
        </>
      ))}

      <div className="row card-footer bg-light p-0 mx-0">
        <button
          className="btn btn-sm btn-link d-block py-2"
          type="button"
          onClick={() => setModalShow(true)}
        >
          Crea un nuovo {scoreType} <FontAwesomeIcon icon="chevron-right" />
        </button>
      </div>
    </div>
  );
};

BonusMalusList.propTypes = {
  scoreType: PropTypes.string.isRequired,
  scoreList: PropTypes.array.isRequired,
  updateTotalPoints: PropTypes.func.isRequired,
  formData: PropTypes.object,
  playerType: PropTypes.string.isRequired
};

export default BonusMalusList;
